import { GlobalAuthProvider } from '@Stores/global/auth';

import { ThemeProvider } from '../Theme';

import AppErrorBoundary from './AppErrorBoundary';
import SystemCheck from './SystemCheck';
import { AppLayoutProvider } from './context';

export default function AppWrapper({ children }) {
  return <GlobalAuthProvider>
    {/* <AppErrorBoundary> */}
    <ThemeProvider>
      <AppLayoutProvider>
        <SystemCheck>
          {children}
        </SystemCheck>
      </AppLayoutProvider>
      {/* </AppErrorBoundary> */}
    </ThemeProvider>
  </GlobalAuthProvider>
}

